import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { TRoutes } from '../../shared/const'
import FlatLink from '../../UI/FlatLink'

import PublicMenu from '../PublicMenu'

import styles from './style.module.scss'

/**
 * Die Kopfleiste der öffentlichen Seiten.
 *
 * Bis 23.08.2026 gab es nur eine öffentliche Seite, und ihre Kopfleiste stand
 * in ihr drin. Seit die Lernstrecke dazugekommen ist, sind es zwei — und zwei
 * Kopfleisten, die gleich aussehen sollen, laufen auseinander. Deshalb steht
 * sie hier: Marke links, **Menü** daneben, was die Seite selbst mitbringt
 * (Suche, Filter) rechts, und ganz außen die Anmeldung.
 *
 * Das Menü selbst steht in `components/PublicMenu` — es hängt seit dem
 * 23.08.2026 auch über den Anmeldeseiten, und zwei Listen derselben Seiten
 * liefen beim nächsten Zuwachs auseinander.
 *
 * **Der Inhalt liegt in einem eigenen Kasten, die Leiste nur darum.** Nur so
 * kann der weiße Grund über die volle Breite laufen, während sich der Inhalt an
 * der Spalte der Seite ausrichtet (`spalte`). Ohne das stand die Marke auf
 * einer Seite mit mittiger Spalte 79 px links vom Seitentitel — auf 1600 px
 * gemessen, und mit jedem Pixel mehr Fensterbreite wurde die Drift größer.
 */

export default function PublicTopBar({ children, spalte }) {
	const { t } = useTranslation()

	return (
		<header className={styles.topBar}>
			<div className={clsx(styles.inner, spalte && styles.innerSpalte)}>
				{/*
				 * Ohne Logo: Die Leiste links (Navbar im abgemeldeten Zustand) trägt
				 * dasselbe Zeichen, und zwei gleiche Logos nebeneinander lesen sich
				 * wie zwei Marken.
				 */}
				<Link to={TRoutes.MAIN} className={styles.brand}>
					<span className={styles.brandText}>
						<span className={styles.brandTitle}>Junior Datenbank</span>
						<span className={styles.brandSubtitle}>
							{t('The Junior Companies of Junior Achievement Austria')}
						</span>
					</span>
				</Link>

				<PublicMenu />

				<div className={clsx(styles.actions, children && styles.actionsBreit)}>
					{children}
					<FlatLink to={TRoutes.SIGN_IN} className={styles.btnSignIn}>
						{t('Login')}
					</FlatLink>
				</div>
			</div>
		</header>
	)
}

PublicTopBar.propTypes = {
	children: PropTypes.node,
	/*
	 * Inhalt in dieselbe mittige Spalte wie der Seiteninhalt (höchstens
	 * 1180 px). Nur für Seiten, die selbst so gebaut sind — die Startseite und
	 * die Berichtsseiten laufen über die volle Breite und richten sich am
	 * Seitenrand aus.
	 */
	spalte: PropTypes.bool
}

PublicTopBar.defaultProps = { spalte: false }
